import { ExclamationTriangleIcon } from '@heroicons/react/16/solid'
import type { DraftState, WizardSampleGroup } from '../../../Model/OrderWizard/OrderWizardDraft.ts'
import { useDispatch } from '../../../Flux/index.ts'
import { orderWizardActions as wizard } from '../../../Flux/Slice/OrderWizard/OrderWizardSlice.ts'
import { groupWriteError } from '../../../Services/OrderWizard/writeState.ts'
import { RETRY_BUTTON } from './retryStyle.ts'

/** What went wrong writing a sample into the order, with a way to write it again. */
export const GroupWriteFailure = ({ draft, group }: { draft: DraftState; group: WizardSampleGroup }) => {
  const dispatch = useDispatch()
  const error = groupWriteError(group)
  if (!error) {
    return null
  }
  return (
    <span className="flex items-center gap-1 text-error" title={error}>
      <ExclamationTriangleIcon className="h-3 w-3 shrink-0" /> <span className="truncate">{error}</span>
      <button
        type="button"
        className={RETRY_BUTTON}
        data-testid="wizard-group-retry"
        onClick={() => dispatch(wizard.groupRetryRequested({ draftId: draft.id, groupKey: group.key }))}
      >
        Try again
      </button>
    </span>
  )
}
